var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"outlined":"","label":_vm.label,"items":_vm.items,"item-text":"full_name","item-value":"id","value":_vm.value},on:{"input":_vm.syncInput}})}
var staticRenderFns = []

export { render, staticRenderFns }